import { render, staticRenderFns } from "./AdminCreate.vue?vue&type=template&id=4007e898&scoped=true&"
import script from "./AdminCreate.vue?vue&type=script&lang=js&"
export * from "./AdminCreate.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreate.vue?vue&type=style&index=0&id=4007e898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4007e898",
  null
  
)

export default component.exports